import React from 'react';
import Header from '../../../header/header';
import Footer from '../../../footer/footer';
import MariageGallery from './mariagegallery';


const Mariage = (props) => {

  return (
    <div>  
            <Header />

    <div id="activites">

      <div className="container">
                   <div className="col-xs-12 col-md-12">
<br></br>
<br></br>

        <div className="section-title">

          <h2 className='evenement'>Mariage & Fiançailles</h2>
             
        </div>
        <div className="activites-list">
  
        <h3 style={{ color: "#DF9BA4" }}>Mariages, fiançailles et moments d’amour</h3>

        <p>
          Je crée des compositions florales uniques pour célébrer vos unions et vos instants précieux : bouquets de mariée, boutonnières, accessoires floraux (couronnes, bracelets, colliers), décoration de véhicules, arches fleuries, centres de table et grands bouquets avec vases ou chandeliers.
        </p>

        <p>
          Chaque création est conçue pour refléter votre histoire et apporter élégance, émotion et fraîcheur à votre événement.
        </p>

        <ul className='lievenements'>
          <li>Bouquet de mariée et accessoires floraux</li>
          <li>Arches fleuries et décoration de cérémonie</li>
          <li>Centres de table et compositions sur mesure</li>
          <li>Décoration de voiture et mise en scène florale</li>
        </ul>
<br></br>

       <MariageGallery />

</div>
      </div>
      </div>
  </div>
      < Footer />

    </div>

  );
};
export default Mariage;